import { useState } from 'react'

/** Which row of a panel is open. One at a time: two open forms is two Saves. */
export function useOneEditing(): {
  editing: string | null
  open: (key: string) => void
  close: () => void
} {
  const [editing, setEditing] = useState<string | null>(null)
  return {
    editing,
    open: (key) => {
      setEditing(key)
    },
    close: () => {
      setEditing(null)
    },
  }
}
